/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Toast_SuccessInputs */

const en_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard!`)
};

const fr_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copie dans le presse-papiers !`)
};

const de_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In die Zwischenablage kopiert!`)
};

const it_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato negli appunti!`)
};

const ru_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано в буфер обмена!`)
};

const es_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Copiado al portapapeles!`)
};

const zh_cn2_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制到剪贴板！`)
};

const ja_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードにコピーされました!`)
};

const hi_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लिपबोर्ड पर कॉपी हो गया!`)
};

const pt_pt2_copy_toast_success = /** @type {(inputs: Copy_Toast_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado para a área de transferência!`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard!" |
*
* @param {Copy_Toast_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_toast_success = /** @type {((inputs?: Copy_Toast_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Toast_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_toast_success(inputs)
	if (locale === "de") return de_copy_toast_success(inputs)
	if (locale === "it") return it_copy_toast_success(inputs)
	if (locale === "ru") return ru_copy_toast_success(inputs)
	if (locale === "es") return es_copy_toast_success(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_toast_success(inputs)
	if (locale === "ja") return ja_copy_toast_success(inputs)
	if (locale === "hi") return hi_copy_toast_success(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_toast_success(inputs)
	return en_copy_toast_success(inputs)
});